import {Component, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {DataService} from '../service/data.service';
import {TableListeService} from '../service/tableListe.service';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit {

  private subscription: Subscription;
  public searchData: any = null;

  constructor(
    private dataService: DataService,
    private tableListService: TableListeService
  ) {
  }

  closeItem(type = '', index = -1) {
    switch (type) {
      case 'theme':
        this.searchData.theme.splice(index, 1);
        break;
      case 'categorie':
        this.searchData.categorie.splice(index, 1);
        break;
      case 'dateDu':
        this.searchData.dateDu = '';
        break;
      case 'dateAu':
        this.searchData.dateAu = '';
        break;
      case 'search':
        this.searchData.search = '';
        break;
    }
    this.dataService.setSearchData(this.searchData);
  }

  hasData() {
    return (this.searchData.categorie && this.searchData.categorie.length !== 0) ||
      (this.searchData.theme && this.searchData.theme.length !== 0) ||
      this.searchData.dateAu !== '' ||
      this.searchData.dateDu !== '' ||
      this.searchData.search !== '';
  }

  search() {
    this.dataService.setMessage('Chargement ...');
    this.tableListService.getListLike(this.searchData).subscribe((list: any) => {
      this.dataService.changeData(list);
    });
  }

  reinitialise() {
    this.dataService.changeData([]);
  }

  ngOnInit() {
    this.subscription = this.dataService.getSearchData().subscribe((data: any) => {
      this.searchData = data;
      console.log(data);
    });
  }

}
